/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection, Separator } from '@fitinsur/components'

import { GeneralSection } from '../../general/index';
import { PartiesEmailInfo } from '../index';

import * as Styled from './styles';

function RenderSection({
  formikProps,
  formikRef,
  emailContentGroup,
  setEmailContentGroup,
  idOperation,
  idOperationParent,
  currentParty,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  mc,
}) {
  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column"}}>
      {emailContentGroup?.map((questions, index) => {
        const idPartyQuestion = questions.find((question) => question.idQuestion === 2199)
        const isCurrentParty = (currentParty.idPersonInsurer == idPartyQuestion.answer)
          return (
            <div style={{display: isCurrentParty ? 'block' : 'none', padding: '0 20px'}}>
              <FormSection
                key={index}
                sectionIndex={index}
                sectionName="PARTIES_EMAIL_INFO"
                formikRef={formikRef}
                values={formikProps.values}
                errors={formikProps.errors}
                setFieldValue={formikProps.setFieldValue}
                setFieldError={formikProps.setFieldError}
                questionnaire={questions}
                idOperation={idOperation}
                idOperationParent={idOperationParent}
                onQuestionChange={(
                  question,
                  value,
                  questionnaireUpdated,
                  setQuestionnaireUpdated
                ) => {
                  PartiesEmailInfo.events.handleQuestionChange({
                    question,
                    value,
                    questionnaireUpdated,
                    updatedObligorGroup: emailContentGroup.map((v, i) => i === index ? questionnaireUpdated : v),
                    setEmailContentGroup,
                  });
                }}
              />
            </div>
          );
        })}
    </div>
  )
}

const components = {
  RenderSection
}

export { components }